export const autoScrollCalendarStorageKey = 'auto-scroll-calendar';
